import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../../src/environments/environment";
import { LanguageService } from "../language/language.service";
import { StorageService } from '../../services/storage/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../../core/services/common/common.service'
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';

// import { RequestOptions, Response } from '@angular/http';
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HttpService {
  constructor(private http: HttpClient, private lang: LanguageService ,  private spinner: NgxSpinnerService,    private commonService: CommonService,
    private navigate: NavigationService,
    ) {}

  query(method, url, authHeader, params?, data? , api_url?) {
    const header = this.header(authHeader);
    console.log("====>>>>>>>>>>.",header)
    const body = data || {};
    let apiUrl = environment.API_URL
    if(api_url == 'openId'){
      apiUrl = environment.AUTH_URL
      return Observable.create(observer => {
        this.http[method](`${apiUrl}${this.retriveLng()}${url}`, body, {
          header: header
        })
        .subscribe(data => {
          observer.next(data);
        },
        error => {
          observer.error(error);

        },
        () => {
          observer.complete();
        }
        
      )
      })
    }
    else{
      return Observable.create(observer => {
        this.http[method](`${apiUrl}${this.retriveLng()}v1/${url}`, body, {
          header: header
        })
        .subscribe(data => {
          observer.next(data);
        },
        error => {
          console.log("ERROR =====",error)
          if(error.status=401 /*&& error.statusText == "Unauthorized"*/ ){
            this.navigate.navigateTo("/login");
          }else{
            this.commonService.getTranslationResponse('errorToastr', 'SOMETHING_WENT_WRONG'); 
          }
          this.spinner.hide()

          observer.error(error);
        },
        () => {
          observer.complete();
        }
        
      )
      })
    }
  }

  retriveLng() {
    return this.lang.getLanguage() + "/";
  }

  header(auth) {
    const myHeader = {};
    myHeader["Content-Type"] = "application/x-www-form-urlencoded";
    myHeader["Content-Type"] = "application/octet-stream";
    myHeader["Content-Type"] = "application/json";
    myHeader["Accept"] = "application/json";
    myHeader["Cache-Control"] = "no-cache";
    myHeader["Pragma"] = "no-cache";
    myHeader["Expires"] = "Sat, 01 Jan 2000 00:00:00 GMT";
    myHeader["If-Modified-Since"] = "0";
    //myHeader["Authorization"] =  localStorage.getItem("token") || "";
    /* myHeader.set("Content-Type", "application/json");
    myHeader.set("Cache-Control", "no-cache");
    myHeader.set("Pragma", "no-cache");
    myHeader.set("Expires", "Sat, 01 Jan 2000 00:00:00 GMT");
    myHeader.set("If-Modified-Since", "0");

    myHeader.set("Accept", "application/json"); */
    if (auth) {
      // myHeader.set("authentication", "*****************");
      myHeader["authentication"] = "*****************";
    }

    return new HttpHeaders(myHeader);
  }
}

/*
 */